import { render, staticRenderFns } from "./NestedCheckboxFacetGroup.vue?vue&type=template&id=206b274f"
import script from "./NestedCheckboxFacetGroup.vue?vue&type=script&lang=ts"
export * from "./NestedCheckboxFacetGroup.vue?vue&type=script&lang=ts"
import style0 from "./NestedCheckboxFacetGroup.vue?vue&type=style&index=0&id=206b274f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports